import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ExchangeFormErrorStatesEnum {
    CreateExchangeFailed = ErrorStateScheduleEnum.ExchangeFormStatesStartIndex,
    UpdateExchangeFailed,
    DeleteExchangeFailed,
    ListExchangeFailed,
}
